export const mbfRank_style = {
  rootSx: {
    marginRight: '-17px',
  },
};
